import angular from 'angular';
import '../../../../services/navigation';

angular.module('folkeuni').component('navigationMenu', {
	templateUrl: '/shop-dist/templates/navigation-menu.html',
	bindings: {
			currentPageId:'@',
			rootId: '@'
	},
	controller: function (Navigation) {
			var $ctrl = this;

			$ctrl.loaded = false;
			$ctrl.menu = [];
			$ctrl.activeItem = null;

			$ctrl.selectItem = function (item) {
				if(item) {
					$ctrl.activeItem = item;
				}
			};

            $ctrl.$onInit = function () {
                Navigation.getNavigation($ctrl.rootId).then(function (navigation) {
						$ctrl.menu = getMenuItems([], navigation);
						$ctrl.activeItem = $ctrl.activeItem || $ctrl.menu[0];
						$ctrl.loaded = true;
				});
			};

            function getMenuItems(menu, item, menuItem) {
               
				menuItem = menuItem ? menuItem : {};
				menuItem.id = item.id;
				menuItem.level = item.level;
				menuItem.name = item.name;
				menuItem.url = item.url;
				menuItem.documentType = item.documentType;
				if(menuItem.documentType == 'FestivalSite'){
					  menuItem.festivalFrontpage = true;
				}
        		menuItem.siteClass = item.siteClass;
				menuItem.color = item.color;

				menu.push(menuItem);

				if(menuItem.id == $ctrl.currentPageId){
						$ctrl.activeItem = menuItem;
				}

				if (item.children && item.children.length > 0) {
					menuItem.children = [];
				}

				for (var i in item.children) {
					var child = item.children[i];

					switch (child.documentType) {
						case 'Microsites':
							for (var c in child.children) {
								var subChild = child.children[c];
								var subChildMenuItem = { parent: menuItem };
								menuItem.children.push(subChildMenuItem);
								getMenuItems(menu, subChild, subChildMenuItem);
							}
							break;
						default:
							var childMenuItem = {parent: menuItem};
							menuItem.children.push(childMenuItem);
							getMenuItems(menu, child, childMenuItem);
							break;
					}
				}

				return menu;
			}
	}
});
